import { useTranslate } from "ra-core";
import { CreateButton } from "@/components/admin/create-button";

import useAppBarHeight from "../misc/useAppBarHeight";

export const ProspectEmpty = () => {
  const appbarHeight = useAppBarHeight();
  const translate = useTranslate();
  return (
    <div
      className="flex flex-col justify-center items-center gap-3"
      style={{ height: `calc(100dvh - ${appbarHeight}px)` }}
    >
      <div className="flex flex-col gap-0 items-center">
        <h6 className="text-lg font-bold">
          {translate("resources.prospects.empty.title", { _: "No prospects yet" })}
        </h6>
        <p className="text-sm text-muted-foreground text-center mb-4">
          {translate("resources.prospects.empty.description", {
            _: "Add a property/owner to start tracking deals.",
          })}
        </p>
      </div>
      <CreateButton label="resources.prospects.action.new" />
    </div>
  );
};
